module.exports = __webpack_public_path__ + "img/about/80243-022.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-022.png
// module id = 19
// module chunks = 0